if (!window.customElements.get('cart-progress')) {
  class CartProgress extends HTMLElement {
    constructor() {
      super();
      this.giftType = this.dataset.giftType;
      this.cartDrawerElement = document.querySelector('cart-drawer');
      this.element = this;
      this.parcelProtectionId = this.dataset.parcelProtectionId;
    }
  
    init() {
      this.testThreshold();
    }
  
    async _getCart() {
      let cartObject;
      try {
        const response = await fetch(`/cart.js`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        cartObject = await response.json();
      } catch (error) {
        console.error("Error fetching cart:", error);
        return;
      }
      return cartObject;
    }
  
    async testThreshold(cart) {
      this.giftLimit = parseInt(this.dataset.giftLimit);
      this.giftLimitTwo = parseInt(this.dataset.giftLimitTwo);
      this.giftLimitThree = parseInt(this.dataset.giftLimitThree);
      
      this.variantId = this.dataset.variantId;
      this.variantIdTwo = this.dataset.variantIdTwo;
      this.variantIdThree = this.dataset.variantIdThree;
  
      this.productId = this.dataset.productId;
      this.productIdTwo = this.dataset.productIdTwo;
      this.productIdThree = this.dataset.productIdThree;
      
      const parcelProtectionPrice = cart.items.find((item) => item.product_id === this.parcelProtectionId)?.final_price || 0;
      const giftCardProducts = cart.items.filter((item) => item.gift_card == true);
      let giftCardPrice = 0;
      if(giftCardProducts.length) {
        giftCardProducts.forEach((item) => {
          giftCardPrice = giftCardPrice + item.final_line_price;
        });
      }
      
      this.cartTotal = cart.total_price - parcelProtectionPrice - giftCardPrice;
      
      this.cart = cart;
      this.togglePlaceholderVisibility();
      await this._autoGiftUpdate();
    }

    togglePlaceholderVisibility() {
      this.giftInCart = this.cart.items.filter((item) => item.variant_id === parseInt(this.variantId));
      if ((this.cartTotal >= this.giftLimit) && !this.giftInCart.length) {
        let placeHolderOne = document.querySelector(`[data-placeholder-gift-item="${this.variantId}"]`);
        if(placeHolderOne) placeHolderOne.classList.remove('hidden');
      }
      if((this.cartTotal < this.giftLimit) && this.giftInCart.length) {
        let placeHolderOne = document.querySelector(`[data-gift-item="${this.variantId}"]`);
        if(placeHolderOne) placeHolderOne.classList.add('hidden');
      }
      
      this.giftInCartTwo = this.cart.items.filter((item) => item.variant_id === parseInt(this.variantIdTwo));
      if ((this.cartTotal >= this.giftLimitTwo) && !this.giftInCartTwo.length) {
        let placeHolderTwo = document.querySelector(`[data-placeholder-gift-item="${this.variantIdTwo}"]`);
        if(placeHolderTwo) placeHolderTwo.classList.remove('hidden');
      } 
      if ((this.cartTotal < this.giftLimitTwo) && this.giftInCartTwo.length) {
        let placeHolderTwo = document.querySelector(`[data-gift-item="${this.variantIdTwo}"]`);
        if(placeHolderTwo) placeHolderTwo.classList.add('hidden');
      }

      this.giftInCartThree = this.cart.items.filter((item) => item.variant_id === parseInt(this.variantIdThree));
      if ((this.cartTotal >= this.giftLimitThree) && !this.giftInCartThree.length) {
        let placeHolderThree = document.querySelector(`[data-placeholder-gift-item="${this.variantIdThree}"]`);
        if(placeHolderThree) placeHolderThree.classList.remove('hidden');
      } 
      if ((this.cartTotal < this.giftLimitThree) && this.giftInCartThree.length) {
        let placeHolderThree = document.querySelector(`[data-gift-item="${this.variantIdThree}"]`);
        if(placeHolderThree) placeHolderThree.classList.add('hidden');
      }
    }
    
    async _autoGiftUpdate() {
      let updates;
      if(this.giftType === 'combine') {
        updates = this._setUpdatesCombine();
      } else {
        updates = this._setUpdatesReplace();
      }
      await this._handleCartUpdate(updates);    
    }
  
    _setUpdatesCombine() {
      let updates = {}; 
      if (this.variantId) {
        this.giftInCart = this.cart.items.filter((item) => item.variant_id === parseInt(this.variantId));
        if ((this.cartTotal >= this.giftLimit) && !this.giftInCart.length) {
          updates[this.variantId] = 1; // Set quantity to 1 if limit is reached
        } else if ((this.cartTotal < this.giftLimit) && this.giftInCart.length) {
          updates[this.variantId] = 0; // Set quantity to 0 if limit is not reached
        }
      }
    
      if (this.variantIdTwo) {
        this.giftInCartTwo = this.cart.items.filter((item) => item.variant_id === parseInt(this.variantIdTwo));
        if ((this.cartTotal >= this.giftLimitTwo) && !this.giftInCartTwo.length) {
          updates[this.variantIdTwo] = 1; // Set quantity to 1 if limit is reached
        } else if ((this.cartTotal < this.giftLimitTwo) && this.giftInCartTwo.length) {
          updates[this.variantIdTwo] = 0; // Set quantity to 0 if limit is not reached
        }
      }

      if (this.variantIdThree) {
        this.giftInCartThree = this.cart.items.filter((item) => item.variant_id === parseInt(this.variantIdThree));
        if ((this.cartTotal >= this.giftLimitThree) && !this.giftInCartThree.length) {
          updates[this.variantIdThree] = 1; // Set quantity to 1 if limit is reached
        } else if ((this.cartTotal < this.giftLimitThree) && this.giftInCartThree.length) {
          updates[this.variantIdThree] = 0; // Set quantity to 0 if limit is not reached
        }
      }
      return updates;
    }
  
    _setUpdatesReplace() {
      let updates = {};
    
      // Helper function to filter cart items by variant ID
      const findItemInCart = (variantId) => 
        this.cart.items.filter((item) => item.variant_id === parseInt(variantId));
    
      // Tiered variants and thresholds
      const tiers = [
        { variantId: this.variantIdThree, giftLimit: this.giftLimitThree },
        { variantId: this.variantIdTwo, giftLimit: this.giftLimitTwo },
        { variantId: this.variantId, giftLimit: this.giftLimit },
      ];
    
      let highestEligibleTier = null;
    
      // Determine the highest eligible tier based on cartTotal
      for (const tier of tiers) {
        if (this.cartTotal >= tier.giftLimit) {
          highestEligibleTier = tier;
          break; // Stop once the highest tier is found
        }
      }
    
      // Loop through each tier and adjust the cart items
      for (const tier of tiers) {
        const { variantId, giftLimit } = tier;
        const giftInCart = findItemInCart(variantId);
    
        if (highestEligibleTier && highestEligibleTier.variantId === variantId) {
          // Add the highest eligible tier if not already in cart
          if (!giftInCart.length) {
            updates[variantId] = 1;
          }
        } else {
          // Remove lower or ineligible tiers
          if (giftInCart.length) {
            updates[variantId] = 0;
          }
        }
      }
    
      return updates;
    }
  
    async _handleCartUpdate(updates) {
     if (Object.keys(updates).length > 0) {
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );
  
        const body = JSON.stringify({
          updates: updates,
          sections: sectionsToBundle,
          sections_url: window.location.pathname
        });
  
        const config = FoxTheme.utils.fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = body;
  
        fetch(`${FoxTheme.routes.cart_update_url}`, config)
          .then((response) => response.json())
          .then(async (parsedState) => {
            if (parsedState.status === 422 || parsedState.status) {
              this.handleCartError(parsedState);
              return;
            }
  
            const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, FoxTheme.utils.fetchConfig())).json();
            cartJson['sections'] = parsedState['sections'];
            this.updateCartState(cartJson);
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
    
    handleCartError(parsedState) {
      document.dispatchEvent(
        new CustomEvent('product-ajax:error', {
          detail: {
            errorMessage: parsedState.description,
          },
        })
      );
      // Display the error message if needed.
    }
  
    updateCartState(cartJson) {
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
      document.dispatchEvent(
        new CustomEvent('product-ajax:added', {
          detail: {
            product: cartJson,
          },
        })
      );
      if (this.cartDrawerElement) {
        this.cartDrawerElement.show(this.element);
      }
    }
  };
  
  window.customElements.define('cart-progress', CartProgress);
}

let cartProgressDebounceTimer;
document.addEventListener('cart:updated', (event) => {
  clearTimeout(cartProgressDebounceTimer);
  cartProgressDebounceTimer = setTimeout(() => {
    const cartProgress = document.querySelector('cart-progress');
    if(cartProgress) {
      cartProgress.testThreshold(event.detail.cart); 
    }
  }, 1000);
});
